import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { UpdateGeneralInfoComponent } from 'app/entities/details/generalinformation/updategeneralinformation/update-general-info.component';
import { GeneralInfo } from 'app/shared/models/general-info.model';
import { GeneralInformationService } from './general-information.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'general-info',
  providers: [GeneralInformationService],
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.css']
})

/**
 * Component to display the general information for the entity.
 */
export class GeneralInformationComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;

  dialogRef: MdDialogRef<any>;
  generalInformationData: string;
  generalInfoLoaded = false;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private generalInformationService: GeneralInformationService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = (this.entityIdDetails.entityType.toString().toLowerCase() == 'person')
        ? this.entityIdDetails.personId
        : this.entityIdDetails.orgId;

      this.getGeneralInfoDesc();
    }
  }

  // Get General Information Text Description..
  getGeneralInfoDesc() {
    this.generalInfoLoaded = false;
    this.generalInformationData = "";
    this.generalInformationService.getGeneralInfoDesc(this.id, this.entityIdDetails.entityType)
        .subscribe(response => {
        this.generalInformationData = response;
        this.generalInfoLoaded = true;
    });
  }

  // Open dialog having text editor to update General Information text.
  openGeneralInfoUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdateGeneralInfoComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argGeneralInfoDetailsData = this.generalInformationData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getGeneralInfoDesc();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/generalinformation/general-information.component.ts